import React, { useState, useEffect } from 'react';
import { avatarPaths } from '../../../utils/avatarUtils';
import ColorPicker from '../../common/ColorPicker';

const NumberInput = ({ value, onChange }) => {
    const handleChange = (e) => {
        const input = e.target.value.replace(/\D/g, '').slice(0, 2);
        const num = input === '' ? 0 : parseInt(input, 10);
        onChange(num);
    };

    return (
        <div className="flex items-center space-x-2">
            <button
                type="button"
                onClick={() => onChange(Math.max(0, parseInt(value) - 1))}
                className="p-2 rounded-lg bg-gray-100 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-popashot-blue-light"
            >
                -
            </button>
            <div className="relative">
                <input
                    type="text"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    value={value || ''}
                    onChange={handleChange}
                    className="w-16 text-center p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-popashot-blue-light"
                    maxLength="2"
                />
            </div>
            <button
                type="button"
                onClick={() => onChange(Math.min(99, parseInt(value) + 1))}
                className="p-2 rounded-lg bg-gray-100 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-popashot-blue-light"
            >
                +
            </button>
        </div>
    );
};

const AvatarSelector = ({ onSelectAvatar, username, initialColor, initialNumber }) => {
    const [selectedColor, setSelectedColor] = useState(initialColor || '#377AD3');
    const [jerseyNumber, setJerseyNumber] = useState(initialNumber ? parseInt(initialNumber) : 0);

    const handleNumberChange = (num) => {
        setJerseyNumber(num);
        onSelectAvatar({
            id: 'jersey',
            color: selectedColor,
            jerseyNumber: num.toString().padStart(2, '0')
        });
    };

    const handleColorChange = (color) => {
        setSelectedColor(color);
        onSelectAvatar({
            id: 'jersey',
            color: color,
            jerseyNumber: jerseyNumber.toString().padStart(2, '0')
        });
    };

    return (
        <div className="flex flex-col items-center space-y-2">
            {/* Container for Avatar and Number Input */}
            <div className="relative w-full max-w-[280px]">
                {/* Avatar Display */}
                <div className="aspect-square w-full p-4">
                    <svg
                        viewBox={avatarPaths.jersey.viewBox}
                        className="w-full h-full"
                        style={{ color: selectedColor }}
                    >
                        {avatarPaths.jersey.content({
                            username: username?.toUpperCase() || '',
                            jerseyNumber: jerseyNumber.toString().padStart(2, '0')
                        })}
                    </svg>
                </div>
                
                {/* Jersey Number Selector - Positioned over bottom of jersey */}
                <div className="absolute bottom-2 left-1/2 transform -translate-x-1/2 bg-white/90 backdrop-blur-sm rounded-lg shadow-lg p-2">
                    <NumberInput
                        value={jerseyNumber}
                        onChange={handleNumberChange}
                    />
                </div>
            </div>

            {/* Color Picker - Reduced padding */}
            <div className="w-full max-w-[280px] px-2 pb-4">
                <ColorPicker
                    color={selectedColor}
                    onChange={handleColorChange}
                />
            </div>
        </div>
    );
};

export default AvatarSelector;
